<template>
    <v-row no-gutters>
        <v-col class="d-flex align-center">
            {{ RatePlan.standardGuestIncluded }} x <v-icon small>mdi-account</v-icon>
        </v-col>
        <v-col>
            <div v-if="IsPackage" style="line-height: 1 !important;" class="my-3">
                {{ RatePlan.room.roomName }}
            </div>

            <div style="line-height: 1 !important;" class="my-3">
                {{ RatePlan.rateName }} <span v-if="RatePlan.isIncludeBreakfast">with Breakfast <v-icon small
                        class="green--text darken-2">mdi-silverware-fork-knife</v-icon></span>
                <span class="green--text darken-2" v-if="RatePlan.isRefundable"><v-badge color="success"
                        content="Refundable" inline></v-badge></span>

            </div>

            <div style="line-height: .8 !important;" class="my-2">

                Maximum Occupancy: {{ RatePlan.maxAllowedGuest }} person(s)
            </div>


            <div v-if="RatePlan.startDate !== null && RatePlan.startDate !== undefined"
                style="line-height: .8 !important;" class="my-2 pink--text darken-2">
                Valid period: {{ formatDate(RatePlan.startDate) }} to {{ formatDate(RatePlan.endDate) }}
                <!-- <span>
                    <v-badge color="#E57373"
                        :content="'Valid period: ' + formatDate(RatePlan.startDate) + ' to ' + formatDate(RatePlan.endDate)"
                        inline></v-badge>
                </span> -->

            </div>


            <!-- <div v-if="RatePlan.hotDealsType !== 'None'" style="line-height: 1 !important;" class="my-3">
                {{
                RatePlan.hotDealsType === 'AmountDiscount' || RatePlan.hotDealsType === 'PercentDiscount' ?
                'DISCOUNT' : ''
                }}
                
                <template v-if="RatePlan.hotDealsType === 'None'">

                </template>
                <v-icon v-if="RatePlan.hotDealsType !== 'PackageDeal' && RatePlan.hotDealsType !== 'PayStayDeal'" small
                    class="red--text darken-2">mdi-fire</v-icon>
            </div> -->

        </v-col>
        <v-col class="d-flex justify-center flex-column align-center">
            <div>
                {{ RatePlan.displayTotalPrice }}
            </div>
            <div class="text-decoration-line-through"
                v-if="RatePlan.hotDealsType === 'PercentDiscount' || RatePlan.hotDealsType === 'AmountDiscount' || RatePlan.hotDealsType === 'FixedAmount'">
                <small>{{ RatePlan.displayOriginalPrice }}</small>
            </div>

            <div>
                <small>Price for {{ RatePlan.priceList.length }} night(s)</small>
            </div>

        </v-col>
        <v-col class="d-flex justify-center align-center">
            {{ availability }}
        </v-col>
        <v-col class="d-flex justify-center align-center">
            <rate-breakdown :IsPackage="false" :RatePlan="RatePlan"></rate-breakdown>
        </v-col>
        <v-col id="rateplanOccupancyOption" class="d-flex justify-space-between align-center">
            <!-- <v-select v-model="selectedUnit" :items="Occupancy" dense solo small-chips> </v-select> -->
            <v-btn class="float-right" v-if="Occupancy.length !== 0 && RatePlan.isValid
            && !(RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length) && RatePlan.isValidPeriod"
                color="deep-purple lighten-2" text @click="reserve"> Book
            </v-btn>
            <div class="float-right text--disabled"
                v-if="Occupancy.length === 0 && !(RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length)"
                color="deep-purple lighten-2" text disabled>
                No more rooms
            </div>
            <div class="float-right text--disabled"
                v-else-if="!RatePlan.isValid && !(RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length) && RatePlan.isValidPeriod"
                color="red darken-1" text disabled>
                {{ RatePlan.minNights }} min nights
            </div>

            <div class="float-right text--disabled"
                v-else-if="RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length && RatePlan.isValidPeriod"
                color="red darken-1" text disabled>
                {{ RatePlan.maxNights }} max nights
            </div>

            <div class="float-right text--disabled" v-else-if="!RatePlan.isValidPeriod" color="red darken-1" text
                disabled>
                Not within valid period
            </div>

            <!-- <div class="float-right text--disabled"
                v-else-if="RatePlan.isPayStayDealInvalid && RatePlan.hotDealsType === 'PayStayDeal' && Occupancy.length !== 0"
                color="red darken-1" text disabled>
                Non Promo Date Selected
                
                && !(RatePlan.isPayStayDealInvalid && RatePlan.hotDealsType === 'PayStayDeal' && Occupancy.length !== 0)
                
            </div> -->


        </v-col>

    </v-row>
</template>

<script>
import moment from 'moment';

import RateBreakdown from './RateBreakdown.vue';

export default {
    components: {
        RateBreakdown
    },
    props: {
        RatePlan: {
            type: Object,
            required: true
        },
        Occupancy: {
            type: Array,
            required: true
        },
        Room: {
            type: Object,
            required: true
        },
        IsPackage: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            selectedUnit: 1
        }
    },
    methods: {
        reserve() {
            // this.RoomRate.occupancy -= this.selectedUnit

            this.$store.dispatch("setSelectedRoomRate", this.RatePlan);
            this.$store.dispatch("setSelectedRoom", this.Room);
            this.selectedUnit = 1;
            this.$store.dispatch('setActiveScreen', 'addRoom');
        },
        formatDate(date) {
            return moment(date).format('DD MMM YY')
        },
    },
    computed: {
        availability: function () {
            if (this.IsPackage) {
                return this.RatePlan.room.availability;
            } else {
                return this.Room.availability;
            }

            return 0;
        }
    }
}

</script>


<style>
#rateplanOccupancyOption div.v-input__slot {
    margin-bottom: -20px !important;
}
</style>